<script>
  //------ Intentionaly blank!
  let defaultSpacer = `





`;
  //------- Intentionaly blank!
</script>

<style lang="scss">
  img {
    width: 60%;
  }

  pre {
    margin: 0;
    font-family: "Epilogue", sans-serif;
  }
</style>

<pre>
{defaultSpacer}
AVAILABLE NOW
ON <i>WARP RECORDS</i>


<img
    src="./hr.png" /><br />


<a
    href="https://magic.pointnever.com/follow">FOLLOW</a>





<img
    src="./hr.png" /><br />


    
<a
    href="https://magic.pointnever.com/">ORDER</a>

<a
    href="https://opn.ffm.to/magic">LISTEN TO 
MAGIC ONEOHTRIX
POINT NEVER</a>

<a
    href="https://opn.ffm.to/merch">MERCH</a>
<!-- DO NOT REMOVE THIS COMMENT -->
{defaultSpacer}
</pre>
